import {Box, Text, Flex} from '@chakra-ui/react';
import {ResponsiveImageType} from 'react-datocms';
import {DatoCmsImage} from '../datocms/image';

interface ImagesWithTitleProps {
  images: ImageWithLinkType[];
  title: string;
  preTitle: string;
  subTitle: string;
}

interface ImageWithLinkType {
  image: ResponsiveImageType;
  linkUrl: string;
}

export const ImagesWithTitle: React.FC<ImagesWithTitleProps> = ({
  images,
  title,
  preTitle,
  subTitle,
}) => {
  return (
    <Box maxW="932px" margin="0 auto">
      <Flex direction="column" mx={{md: '8px'}} mb={{base: '16px', md: '24px'}}>
        <Text as="h6" textStyle={{base: 'h7', md: 'h6'}}>
          {preTitle}
        </Text>
        <Text as="h3" textStyle={{base: 'h5', md: 'h3'}}>
          {title}
        </Text>
        <Text as="h6" textStyle="h7">
          {subTitle}
        </Text>
      </Flex>
      <Flex
        direction={{base: 'column', md: 'row'}}
        justifyContent="space-between"
      >
        {images.map((displayImage: ImageWithLinkType, index) => (
          <Flex
            ml={{md: index % 2 === 0 ? 0 : '16px'}}
            mr={{md: index % 2 !== 0 ? 0 : '16px'}}
            justifyContent={{md: index % 2 === 0 ? 'flex-start' : 'flex-end'}}
            py="4px"
            w="100%"
          >
            <a
              href={displayImage.linkUrl || undefined}
              target="_blank"
              rel="noopener noreferrer"
            >
              <DatoCmsImage
                responsiveImage={displayImage.image}
                style={{borderRadius: '12px'}}
              />
            </a>
          </Flex>
        ))}
      </Flex>
    </Box>
  );
};
